import { WebhookUrls } from '@ess/jg-rule-executor';
import { GetAllRetailers_allRetailers_edges_node_retailerOptions_webhookOptions_webhookUrls } from '@src/app/generated/GetAllRetailers';
import { WebhookUrlsInput } from '@src/app/generated/globalTypes';

export class PortalWebhookUrls extends WebhookUrls {
  constructor(redirectUrl: string) {
    super(redirectUrl);
  }

  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_webhookOptions_webhookUrls
  ): PortalWebhookUrls {
    return new PortalWebhookUrls(gql.redirectUrl);
  }

  public toGqlInput(): WebhookUrlsInput {
    return {
      redirectUrl: this.redirectUrl,
    };
  }
}
